import 'css-chunksrc/client/pages/calendarPage/sideBar/project/styles.scss';export default {
  "project": "_project_8vzjr_1",
  "selected": "_selected_8vzjr_17",
  "icon": "_icon_8vzjr_22",
  "arrow": "_arrow_8vzjr_30",
  "folder": "_folder_8vzjr_40",
  "colorIconWrapper": "_colorIconWrapper_8vzjr_44",
  "checked": "_checked_8vzjr_56",
  "name": "_name_8vzjr_71"
};